import BaseUIImportAddCustomerView from 'xui/modules/importExcel/BaseUIImportAddCustomerView'
// import { View } from 'react-native'
import Dropzone from 'react-dropzone'
import { View, TouchableOpacity } from 'react-native'
import { COLORS, STYLES } from 'x/config/styles'
import XIcon from 'xui/components/XIcon'
import p from 'x/config/platform-specific'
import _ from 'lodash'
import * as util from 'x/utils/util'
import CONS from 'x/config/constants'
import { getConfig } from 'x/config/mode'
import axios from 'axios'
import XText from 'xui/components/XText'
import { downloadFileFromUrl } from '../../utils/util-web'

export default class ImportAddCustomerView extends BaseUIImportAddCustomerView {
  _handleOnDownloadFile = async (url: string, fileName: string) => {
    await downloadFileFromUrl({ url, fileName })
  }

  openLinkOrderToWebView(url: string) {
    try {
      // @ts-ignore
      window.open(url, '_blank')
    } catch (error) {
      // log(error)
    }
  }

  _renderDropzone = () => {
    const { fileUpload } = this.state
    const lableDropZone = _.isNil(fileUpload) ? `วาง Excel ไฟล์ไว้ตรงนี้\nหรือกดตรงนี้เพื่อเลือกไฟล์` : `ไฟล์ที่เลือก\n"${fileUpload.name}"`
    // const lableDropZone = `TEST`
    const borderStyle = _.isNil(fileUpload) ? 'dashed' : 'solid'
    return (
      <View style={{ width: '100%', height: 150, justifyContent: 'center', alignItems: 'center', backgroundColor: COLORS.WHITE }}>
        <Dropzone
          onDrop={(acceptedFiles) => {
            // @ts-ignore
            this._setFileUpload(acceptedFiles)
          }}
          accept='.xls, .xlsx'
          multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <TouchableOpacity style={{ width: `100%`, paddingLeft: 4, paddingRight: 4, paddingTop: 4, paddingBottom: 4 }}>
              <div style={{ backgroundColor: COLORS.BG_LIGHT_GREY, borderRadius: 10 }} {...getRootProps()}>
                <input {...getInputProps()} />
                <View
                  style={{
                    height: 150,
                    width: '100%',
                    borderWidth: 0.8,
                    borderColor: COLORS.APP_MAIN,
                    borderStyle,
                    borderRadius: 10,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingLeft: 6,
                    paddingRight: 6,
                  }}>
                  <XText variant='active' textAlign='center'>
                    {lableDropZone}
                  </XText>
                  {_.isNil(fileUpload) ? null : (
                    <XIcon
                      name='checkcircle'
                      family='AntDesign'
                      style={{ flex: 0, minWidth: 25, width: 40, color: COLORS.GREEN, fontSize: STYLES.FONT_ICON_LARGER }}
                    />
                  )}
                </View>
              </div>
            </TouchableOpacity>
          )}
        </Dropzone>
      </View>
    )
  }

  onPressUpload = async () => {
    const { selectedStore, subscription } = this.props
    if (subscription.get('type') === CONS.SUBSCRIPTION_PACKAGE.FREE) {
      p.op.alert(p.op.t('Subscription.warning.insufficientTypeTitle'), p.op.t('Subscription.warning.insufficientTypeMsg'))
      return
    }
    const { fileUpload } = this.state
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, {
      isLoading: true,
    })
    // console.log('fileUpload => ', fileUpload)
    // ไฟล์ใหญ่กว่า 5 MB ไม่ให้อัปโหลด
    // if (fileUpload && fileUpload.size && fileUpload.size > 5242880) {
    //   await this._alertMaxFileSize()
    //   return
    // }

    // const fileExtension = fileUpload.name.split('.')[1]
    // const fileExtension = fileUpload.name.slice(-4)
    // // console.log(fileExtension) // Output: "xlsx"
    // // รองรับแค่ไฟล์ xlsx
    // if (fileExtension !== 'xlsx') {
    //   await this._alertFileNotSupport()
    //   return
    // }

    const formData = new FormData()

    // Array.from(this.state.fileUpload).forEach(image => {
    // // @ts-ignore
    //   formData.append('file', image)
    // })
    // @ts-ignore
    formData.append('file', fileUpload)
    // formData.append('store_id', `${selectedStore.get('id')}`)
    formData.append('store_id', `${selectedStore.get('id')}`)
    // console.log(`formData`, formData)
    const token = await p.op.storageGet(CONS.AUTHENTICATION_STORAGE_KEY, false)
    // console.log(`TOKEN => `, `Bearer ${token}`)
    // return
    const path = `excel/import/user_contact`
    const url = getConfig()
    axios
      .post(`${url.app_goApiRoot}/${path}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
          // 'Access-Control-Allow-Origin': '*',
          // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        },
        timeout: 60000,
      })
      .then(async (res) => {
        // @ts-ignore res
        // console.log('REF => ', res)
        if (res.data && res.data.status === 'ok') {
          this.inProcess = false
          // const errorText = res.data.import_error.error_code === '' ? null : res.data.import_error.error_code
          // if (errorText !== null) {
          //   const textErrorCode = util.getBgTaskErrorText(errorText)
          //   p.op.showConfirmationOkOnly('', textErrorCode)
          // }

          await util.setStatePromise(this, {
            isLoading: false,
            // successAddProduct: res.data.success,
            // importErrorColumn: res.data.import_error.column === '' ? null : res.data.import_error.column,
            // importErrorCode: errorText,
            // importErrorRow: res.data.import_error.index,
          })
          p.op.showConfirmationOkOnly('', 'เพิ่มลูกค้าเสร็จสิ้น')
          this._goBack()
          return
        }
        // console.log('ERRR => ', res.data.error.error_code)
        if (res.data && res.data.error && res.data.error.error_code) {
          // console.log('ERRR // => ', res.data.error.error_code)
          p.op.showConfirmationOkOnly('เกิดข้อผิดพลาด', p.op.t(`e_msg_by_error_code.${res.data.error.error_code}.m`))

          // if (util.isXSellyErrorV2(res.data)) {
          //   const tt = util.parseXSellyErrorToTitleText(res.data.error)
          //   const mm = util.parseXSellyErrorToMessageText(res.data.error)
          //   p.op.showConfirmationOkOnly(tt, mm)
          // }
          await this._stopLoading()
          return
        }
        this.inProcess = false
        p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${res}`)
        await util.setStatePromise(this, {
          isLoading: false,
        })

        this.inProcess = false
        await util.setStatePromise(this, {
          isLoading: false,
        })
      })
      .catch(async (err) => {
        console.log('err => ', err)
        const errorData = !_.isNil(err.error_code) ? err.error_code : null
        if (!_.isNil(errorData)) {
          p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${errorData}`)
          this.inProcess = false
          await util.setStatePromise(this, {
            isLoading: false,
          })
          return
        }
        p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${err}`)
        this.inProcess = false
        await util.setStatePromise(this, {
          isLoading: false,
        })
      })
  }
}
